module.exports = __webpack_public_path__ + "static/media/ALL TOOLS.ed2c8bee.png";